import React, { Fragment, useContext, useEffect, useState, memo } from "react";

// Provider
import { AppContext } from "../../components/AppProvider";

// Utils
import { _O } from "../../modules/utils";
import { Container, IntroContainer } from "../Layout";

// Images
import _purple_main_img01 from "../../resources/images/sub/purple_main_img01p.png";
import _purple_main_img02 from "../../resources/images/sub/purple_main_img02p.png";
import { userHabit } from "../../modules/utils/UserHabit";
import { NativeAction } from "../../modules/utils/HandleWs";
import { setCookie } from "../../modules/utils/cookie";

export default () => {
    const { userinfo, mypagecfg, auth, cfg, phonecfg, dispatch } = useContext(AppContext);
    useEffect(()=>{
        userHabit(phonecfg, 'PF010');
        NativeAction(phonecfg, "statusColor", "#A5AEE4");
    }, [phonecfg.version]);

    useEffect(() => {
        setCookie('introAge', true, 21);
    }, []);
    
    return(
        <Fragment>
            {/* <IntroContainer url="/proof/apply"> */}
            <IntroContainer url="/pmr/proofRecipt">
                <div>
                    <div className="top-box">
                        <div>
                            <b>
                                언제 어디서나 제증명서류를<br/>
                                발급 받을 수 있습니다.
                            </b>
                            <p>
                                병원에서 기다릴 필요없이 내 핸드폰으로 <br/>
                                서류 발급이 한번에 가능합니다.
                            </p>
                        </div>
                    </div>
                    <div className="imgbox" >
                        <div>
                            <img src={_purple_main_img01} alt="" />
                        </div>
                    </div>
                </div>
                <div>
                    <div className="top-box">
                        <div>
                            <b>
                                서류발급에서 보험청구가<br/>
                                한번에 가능합니다.
                            </b>
                            <p>
                                복잡한 서류발급과 보험청구를 내 핸드폰에서<br/>
                                쉽고 빠르게 신청이 가능합니다.
                            </p>
                        </div>
                    </div>
                    <div className="imgbox">
                        <div>
                            <img src={_purple_main_img02} alt="" />
                        </div>
                    </div>
                </div>
            </IntroContainer>
        </Fragment>
    );
}